import React from 'react';
import SnackbarContentWrapper from "../components/common/SnackBar";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';

const styles = ({
    success: {
        position: "fixed",
        zIndex: "1400",
        width: "100%",
        bottom: "5px",
        right: "10px"
    },
});



export class Notifications extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            notifications: []
        };
        // Id of the notification already taken from the store. Guards against acting
        // on the same one again on every later render.
        this.handledId = null;
    }
    
    componentDidUpdate = (prevProps) => {
        this.addNotification(this.props.notifications);
    }

    addNotification = (notification) => {
        if (!notification || notification.id === this.handledId) {
            return;
        }
        this.handledId = notification.id;

        // Sugar sends a clear when a request returns, to take down the "processing"
        // toast. Errors survive it: they say why the request failed.
        if (notification.variant === "clear") {
            this.setState(state => ({
                notifications: state.notifications.filter(n => n.variant === "error")
            }));
            return;
        }

        this.setState(state => (
            state.notifications.some(n => n.message === notification.message && n.variant === notification.variant)
                ? null
                : { notifications: state.notifications.concat(notification) }
        ));
    }

    // By id, not by index: an earlier toast closing shifts every index after it.
    handleCloseSnack = (id) => {
        this.setState(state => ({
            notifications: state.notifications.filter(n => n.id !== id)
        }));
    }
    
    render = () => {
        const {t} = this.props;
        return (
            <div  className={clsx(this.props.classes.success)}>
                { (this.state.notifications || []).map((notification) => (
                    <div style={{marginBottom : "5px"}} key={"divsnack" + notification.id} >
                        <SnackbarContentWrapper key={"snack" + notification.id}
                            onClose={() => this.handleCloseSnack(notification.id)}
                            open={true}
                            message={
                                notification.isTranslated ? notification.message :
                                t(notification.message)
                            }
                            variant={notification.variant}
                        />
                    </div>
                    
                ))}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        notifications: state.notifications
    };
}

export default connect(
    mapStateToProps
)(compose(withTranslation('common'), withStyles(styles))(Notifications));
